export const month_year = [
    {label: 'Enero', value: 1},
    {label: 'Febrero', value: 2},
    {label: 'Marzo', value: 3},
    {label: 'Abril', value: 4},
    {label: 'Mayo', value: 5},
    {label: 'Junio', value: 6},
    {label: 'Julio', value: 7},
    {label: 'Agosto', value: 8},
    {label: 'Septiembre', value: 9},
    {label: 'Octubre', value: 10},
    {label: 'Noviembre', value: 11},
    {label: 'Diciembre', value: 12},
];

export const year = () => {
    const quantityYear = 4;
    let actualYear = new Date().getFullYear();
    const arrayYear = [];

    arrayYear.push({ label: actualYear, value: actualYear });

    for(let i =0; i < quantityYear; i++){
        actualYear = actualYear - 1;
        arrayYear.push({ label: actualYear, value: actualYear });
    }

    return arrayYear.reverse();

}